import {
  NODE_CONNECTION_TRIGGERED_EVENT
} from "../../../nodes/utils/io/NodeConnection";
export class SceneConnectionTriggerDispatcher {
  constructor() {
    this._dispatchedConnections = /* @__PURE__ */ new Set();
  }
  dispatchTrigger(connection) {
    var _a;
    (_a = connection._eventDispatcher()) == null ? void 0 : _a.dispatchEvent(NODE_CONNECTION_TRIGGERED_EVENT);
    this._dispatchedConnections.add(connection);
  }
}
